import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { UrgencySignal } from '../../../state/infiniteCalendarSeries';
import { FewTicketsLeftSvg } from '../assests/FewTicketsLeftSvg';
import { color_mood_mellow_mellow_pink_300 } from '../colorContants';

// TODO: Add more icons
const signalConfigs = {
    fewTickets: {
        icon: <FewTicketsLeftSvg />,
        bgColor: color_mood_mellow_mellow_pink_300,
    },
};

const createSignal = (type: keyof UrgencySignal, text: string) => {
    const config = signalConfigs[type as keyof typeof signalConfigs];
    return {
        icon: config?.icon ?? null,
        bgColor: config?.bgColor ?? '',
        text: text,
    };
};

export const urgencySignals: Record<
    keyof UrgencySignal,
    { icon: JSX.Element; bgColor: string; text: string }
> = {
    fewTickets: createSignal(
        'fewTickets',
        gettext('Few tickets left').toString(),
    ),
    salesEndSoon: createSignal(
        'salesEndSoon',
        gettext('Tickets sales end soon').toString(),
    ),
    new: createSignal('new', gettext('New').toString()),
    popular: createSignal('popular', gettext('Popular').toString()),
    goingFast: createSignal('goingFast', gettext('Going fast').toString()),
};
